import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeadingArea from '../../general/HeadingArea';
import { FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill, Bs4CircleFill, Bs5CircleFill } from 'react-icons/bs';
import UserLogo from '../../assets/user-logo.png';


const EditStudent = ({ setLoading }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const student = location.state?.student;
        const [lastReg, setLastReg] = useState([]);
          const [ay, setAy] = useState([]);
const [imagePreview, setImagePreview] = useState(null);

  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [showPassword, setShowPassword] = useState(false);
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [formData, setFormData] = useState({
          ay: '',
            name: '',
            reg_no: '',
            admission_no: '',
            roll_no: '',
            pen_no: '',
            apaar_no: '',
            dob: '',
            dor_reg: '',
            doa: '',
            class_id: '',
            section: '',
    gender: '',
    religion: '',
    nationality: '',
    father: '',
    f_occupation: '',
    f_mobile: '',
    f_qualification: '',
    f_email: '',
    mother: '',
    m_occupation: '',
    m_mobile: '', 
    m_qualification: '',
    m_email: '',
    address: '',
    blood_grp: '',
    mobile: '',
    email: '',
    pass: '',
    old_school_detail: '',
    category: '',
    m_tongue: '',
    siblings: [],
    single_girl_child: 'No',
    specially_abled: 'No',
    aadhaar_no: '',
    tc_no: '',
    tc_issue_date: '',
    fee_discount: '',
    // bank_name: '',
    // ifsc_code: '',
    // acc_holder: '',
    // acc_no: '',
    aadhaar_pic: null,
    profile_pic: null,
  });

  useEffect(() => {
    if (!student) {
      navigate('/admin/all-students');
      return;
    }

    // Pre-fill form with student data
    setFormData({
      ay: student.ay || '',
      name: student.name || '',
      reg_no: student.reg_no || '',
      admission_no: student.admission_no || '',
      roll_no: student.roll_no || '',
      pen_no: student.pen_no || '',
      apaar_no: student.apaar_no || '',
      dob: student.dob || '',
      dor_reg: student.dor_reg || '',
      doa: student.doa || '',
      class_id: student.class_name || '',
      section: student.section || '',
      gender: student.gender || '',
      religion: student.religion || '',
      nationality: student.nationality || '',
      father: student.father || '',
      f_occupation: student.f_occupation || '',
      f_mobile: student.f_mobile || '',
      f_qualification: student.f_qualification || '',
      f_email: student.f_email || '',
      mother: student.mother || '',
      m_occupation: student.m_occupation || '',
      m_mobile: student.m_mobile || '',
            m_qualification: student.m_qualification || '',
      m_email: student.m_email || '',
      address: student.address || '',
      blood_grp: student.blood_grp || '',
      mobile: student.mobile || '',
      email: student.email || '',
      pass: student.pass || '',
      old_school_detail: student.old_school_detail || '',
      category: student.category || '',
      m_tongue: student.m_tongue || '',
 siblings:
        student.siblings && typeof student.siblings === 'string'
          ? JSON.parse(student.siblings)
          : student.siblings || [],
                single_girl_child: student.single_girl_child || 'No',
      specially_abled: student.specially_abled || 'No',
            aadhaar_no: student.aadhaar_no || '',
            tc_no: student.tc_no || '',
            tc_issue_date: student.tc_issue_date || '',
            fee_discount: student.fee_discount || '',
                  aadhaar_pic: student.aadhaar_pic || null,
      profile_pic: student.profile_pic || null,
    });

  }, [student, navigate]);

  console.log(student);

      const fetchLastReg = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-last-regno');
     
                      if (response.ok) {
                          const data = await response.json();
                          setLastReg(data.reg_no);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          setLastReg(null);
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


         const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                           setClasses(data);
                           setLoading(false);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }


          const fetchAcademicYears = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/get-academic-years');

    if (response.ok) {
      const data = await response.json();
      setAy(data);
    } else {
      console.error('Failed to fetch academic years');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchLastReg();
    fetchClasses();
    fetchAcademicYears();
  }, []);

useEffect(() => {
  if (formData.class_id) {
    const selectedClass = classes.find((cls) => cls.class_name === formData.class_id);
    if (selectedClass && selectedClass.sections) {
      const sectionsArr = selectedClass.sections.split(',').map((s) => s.trim()).filter((s) => s !== '');
      setAvailableSections(sectionsArr);
    } else {
      setAvailableSections([]);
    }
  } else {
    setAvailableSections([]);
  }
}, [formData.class_id, classes]);


const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === 'profile_pic' && files && files[0]) {
    const file = files[0];
    setFormData((prev) => ({
      ...prev,
      profile_pic: file,
    }));

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  }  if (name === 'aadhaar_pic' && files && files[0]) {
    const file = files[0];
    setFormData((prev) => ({
      ...prev,
      aadhaar_pic: file,
    }));
    // Create preview URL
    // const previewUrl = URL.createObjectURL(file);
    // setImagePreview(previewUrl);
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'class_id' ? { section: '' } : {}),
    }));
  }
};


  const handleSiblingChange = (index, field, value) => {
    const updated = [...formData.siblings];
    updated[index][field] = value;
    setFormData({ ...formData, siblings: updated });
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const submitData = new FormData();

  for (const key in formData) {
      if (key === 'profile_pic') {
        if (formData.profile_pic instanceof File) {
          // New image file selected, append file
          submitData.append('profile_pic', formData.profile_pic);
        } else if (typeof formData.profile_pic === 'string' && formData.profile_pic.trim() !== '') {
          // No new image, send the old image path as a separate field (you can name it 'old_profile_pic' or same name)
          submitData.append('old_profile_pic', formData.profile_pic);
        }
      } else if (key === 'aadhaar_pic') {
        if (formData.aadhaar_pic instanceof File) {
          // New image file selected, append file
          submitData.append('aadhaar_pic', formData.aadhaar_pic);
        } else if (typeof formData.aadhaar_pic === 'string' && formData.aadhaar_pic.trim() !== '') {
          // No new image, send the old image path as a separate field (you can name it 'old_profile_pic' or same name)
          submitData.append('old_aadhaar_pic', formData.aadhaar_pic);
        }
      } 
      else if (key === 'class_id') {
        submitData.append('class_name', formData.class_id);
      }  else if (key === 'siblings') {
    submitData.append('siblings', JSON.stringify(formData.siblings));
  } else  {
        submitData.append(key, formData[key]);
      }
    }

    // API call
    const response = await fetch(`https://api.kcian.in/edit-student/${student.id}`, {
      method: 'PUT',
      body: submitData,
    });

    const data = await response.json();

    if (response.ok) {
      setResponse2({ message: data.message || 'Student updated successfully!', status: 'success' });
      setTimeout(() => {
        setResponse2({ message: '', status: 'success' });
        navigate('/admin/all-students');
      }, 2000);
    } else {
      setResponse2({ message: data.message || 'Something went wrong. Please try again later.', status: 'error' });
      setTimeout(() => {
        setResponse2('');
      }, 2000);
    }
  } catch (error) {
    console.error('Error updating student:', error);
  }
};


  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Student' message2='Edit Student' />
          <p className='text-center profile-heading'>Edit Student Form</p>

          <form onSubmit={handleSubmit}>
<div className='row'>

<div className='col-12 my-3 text-center'>
<img
  src={
    imagePreview
      ? imagePreview
      : formData.profile_pic && formData.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${formData.profile_pic}`
      : UserLogo
  }
  className='emp-img'
  alt="Profile"
/>

</div>

    <p className='fw-semibold border-bottom mb-5'><Bs1CircleFill /> Basic Information</p>
            {/* Reg No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>{lastReg == null ? 'Registration No' : `Last Reg No ${lastReg}`}</label>
                <input type='text' name='reg_no' value={formData.reg_no} onChange={handleChange} className='profile-input' disabled />
              </div>
            </div>


            {/* Admission No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Admission No*</label>
                <input type='text' name='admission_no' value={formData.admission_no} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

            {/* PEN No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>PEN No</label>
                <input type='text' name='pen_no' value={formData.pen_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Full Name*</label>
                <input
                  type='text'
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  className='profile-input'
                  required
                />
              </div>
            </div>


                        {/* Roll No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Roll No*</label>
                <input type='text' name='roll_no' value={formData.roll_no} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

           {/* Mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mobile Number*</label>
                <input type='tel' name='mobile' value={formData.mobile} maxLength={10} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

{/* Date of Birth */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Birth</label>
                <input type='date' name='dob' value={formData.dob} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* DOR */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Registration</label>
                <input type='date' name='dor_reg' value={formData.dor_reg} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* DOA */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Admission*</label>
                <input type='date' name='doa' value={formData.doa} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


            {/* Password */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area' style={{ position: 'relative' }}>
    <label className='profile-badge'>Password*</label>
    <input
      type={showPassword ? 'text' : 'password'}
      name='pass'
      value={formData.pass}
      onChange={handleChange}
      className='profile-input'
      readOnly
      required
    />
    <span
      onClick={() => setShowPassword((prev) => !prev)}
      style={{
        position: 'absolute',
        right: '15px',
        top: '15px',
        cursor: 'pointer',
        color: '#888'
      }}
    >
      {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
    </span>
  </div>
</div>


                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select AY*</label>
                    <select
                      className="profile-input"
                      name='ay'
                      value={formData.ay}
      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Academic Year --</option>
                      {ay.map((ayear) => (
                        <option key={ayear.year} value={ayear.year}>
                          {ayear.year} --- {ayear.title}
                        </option>
                      ))}
                    </select>
</div>
                  </div>


                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
<select
  className="profile-input"
  name="class_id"
  value={formData.class_id}
  onChange={handleChange}
  required
>
  <option value="">-- Select Class --</option>
  {classes.map((cls) => (
    <option key={cls.id} value={cls.class_name}>
      {cls.class_name}
    </option>
  ))}
</select>

</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  name="section"
  value={formData.section}
  onChange={handleChange}
  required
  disabled={availableSections.length === 0}
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>


                    </div>
                  </div>


            {/* <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Discount on Fee (if Any)</label>
                <input type='text' name='fee_discount' value={formData.fee_discount} onChange={handleChange} className='profile-input' />
              </div>
            </div> */}


                              <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Category*</label>
<select
  className="profile-input"
  name="category"
  value={formData.category}
  onChange={handleChange}
  required
>
  <option value="">-- Select Category --</option>
                  <option value=''>Select Category</option>
                  <option value='General'>General</option>
                  <option value='EWS'>EWS</option>
                  <option value='OBC'>OBC</option>
                  <option value='SC'>SC</option>
                  <option value='ST'>ST</option>
                  <option value='Other'>Other</option></select>
                    </div>
                  </div>


            {/* PEN No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Apaar Id</label>
                <input type='text' name='apaar_no' value={formData.apaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


    <p className='fw-semibold border-bottom mb-5'><Bs2CircleFill /> Aadhaar Details</p>

{/* Aadhar no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar No</label>
                <input type='text' name='aadhaar_no' value={formData.aadhaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar Pdf</label>
                <input type='file' name='aadhaar_pic' accept='application/pdf' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <p className='para-text fw-bold mb-4'>Whether the candidate is: -</p>

{/* Single Girl Child */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Single Girl Child?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'No' || !formData.single_girl_child ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>

{/* Specially Abled */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Specially abled?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'No' || !formData.specially_abled ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>


    <p className='fw-semibold border-bottom mb-5'><Bs3CircleFill /> Other Information</p>

            {/* Profile Picture */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Profile Picture</label>
                <input type='file' name='profile_pic' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Blood Group */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Blood Group</label>
                <input type='text' name='blood_grp' value={formData.blood_grp} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* User ID */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Email Address</label>
                <input type='email' name='email' value={formData.email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Gender */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Gender</label>
                <select name='gender' value={formData.gender} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Gender</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Religion */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Religion</label>
                <select name='religion' value={formData.religion} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Religion</option>
                  <option value='Hinduism'>Hinduism</option>
                  <option value='Muslim'>Muslim</option>
                  <option value='Non Muslim'>Non Muslim</option>
                  <option value='Christianity'>Christianity</option>
                  <option value='Islam'>Islam</option>
                  <option value='Jainism'>Jainism</option>
                  <option value='Buddhism'>Buddhism</option>
                   <option value='Sikhism'>Sikhism</option>
                  <option value='Non Religious'>Non Religious</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Nationality */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Nationality</label>
                <input type='text' name='nationality' value={formData.nationality} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* mother tongue */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Tongue</label>
                <input type='text' name='m_tongue' value={formData.m_tongue} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* TC No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC (Transfer Certificate) No</label>
                <input type='text' name='tc_no' value={formData.tc_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* TC Date */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC Issue Date</label>
                <input type='date' name='tc_issue_date' value={formData.tc_issue_date} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Address */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Address</label>
                <textarea name='address' value={formData.address} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>

            {/* Old School */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Old School Detail</label>
                <textarea name='old_school_detail' value={formData.old_school_detail} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>


                <p className='fw-semibold border-bottom mb-5'><Bs4CircleFill /> Guardian Information</p>

{/* Father name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father Name</label>
                <input type='text' name='father' value={formData.father} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='f_occupation' value={formData.f_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Mobile No</label>
                <input type='tel' name='f_mobile' value={formData.f_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Email</label>
                <input type='text' name='f_email' value={formData.f_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Qualification</label>
                <input type='text' name='f_qualification' value={formData.f_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <div className='mb-4 col-md-4'>
</div>


{/* Mother name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Name</label>
                <input type='text' name='mother' value={formData.mother} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='m_occupation' value={formData.m_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Mobile No</label>
                <input type='tel' name='m_mobile' value={formData.m_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Email</label>
                <input type='text' name='m_email' value={formData.m_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Qualification</label>
                <input type='text' name='m_qualification' value={formData.m_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

                        <div className='mb-4 col-md-4'>
</div>


                <p className='fw-semibold border-bottom mb-5'><Bs5CircleFill /> Siblings Details (if Any)</p>


<div className='col-12'>
  {formData.siblings.length > 0 &&
    formData.siblings.map((sibling, index) => (
      <div key={index} className='row align-items-end mb-4'>
        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Name</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.name}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].name = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Relation</label>
            <select
              className='profile-input'
              value={sibling.relation}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].relation = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            >
              <option value=''>Select</option>
              <option value='Brother'>Brother</option>
              <option value='Sister'>Sister</option>
            </select>
          </div>
        </div>

        <div className='col-md-2'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Age</label>
            <input
              type='number'
              className='profile-input'
              value={sibling.age}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].age = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>School Studying</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.school_studying}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].school_studying = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-1 text-end'>
          <button
            type='button'
            className='btn btn-danger rounded-circle'
            onClick={() => {
              const updated = [...formData.siblings];
              updated.splice(index, 1);
              setFormData({ ...formData, siblings: updated });
            }}
          >
            −
          </button>
        </div>
      </div>
    ))}

  <button
    type='button'
    className='profile-btn2 float-end'
    onClick={() =>
      setFormData({
        ...formData,
        siblings: [
          ...formData.siblings,
          { name: '', relation: '', age: '', school_studying: '' }
        ]
      })
    }
  >
    + Add Sibling
  </button>
</div>


<div className='px-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

            {/* Submit button */}
            <div className='col-12'>
            <button className='profile-btn2 me-2' onClick={() => navigate('/admin/all-students')}>Go Back</button>
              <button type='submit' className='profile-btn'>
                <FaCheck /> Update
              </button>
            </div>

            </div>
          </form>

        </div>
      </section>
    </>
  );
};

export default EditStudent;
